import { render, staticRenderFns } from "./RequestItemEdit.vue?vue&type=template&id=c4802d7e&"
import script from "./RequestItemEdit.vue?vue&type=script&lang=ts&"
export * from "./RequestItemEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports